import React from 'react';
import { useTournament } from '../hooks/useTournament';

const FieldSettings = () => {
  const { numFields, updateFields } = useTournament();

  const handleIncrease = () => {
    updateFields(numFields + 1);
  };

  const handleDecrease = () => {
    if (numFields > 1) {
      updateFields(numFields - 1);
    }
  };

  return (
    <div className="section">
      <div className="section-header">
        <h2>Verfügbare Felder</h2>
      </div>
      <div className="number-input-container">
        <div className="number-input-label">
          <i className="icon field-icon">🏟️</i>
          <span>Anzahl der Fußballfelder:</span>
        </div>
        <div className="number-input-control">
          <button 
            className="number-control-button"
            onClick={handleDecrease}
            disabled={numFields <= 1}
          >
            −
          </button>
          <span className="number-display">{numFields}</span>
          <button 
            className="number-control-button"
            onClick={handleIncrease}
            disabled={numFields >= 25}
          >
            +
          </button>
        </div>
      </div>
      <p className="info-text">Geben Sie die Anzahl der verfügbaren Fußballfelder für das Turnier ein.</p>
    </div>
  );
};

export default FieldSettings;